<label class="radio-label">{{ field.name }}</label>
<mat-radio-group class="radio-group" [formControl]="fc">
    @for (option of field.options; track option.key) {
        <mat-radio-button [value]="option.key" color="primary">
            {{ option.name }}
        </mat-radio-button>
    }
</mat-radio-group>
